export default __webpack_public_path__ + "static/Mazda_Mob-a1fd162d390389f530a45736bc6085c8.png";